import { useEffect, useState, type FC } from "react";
import { Button, Input, MaskedInput, Modal, SelectPicker } from "rsuite";
import { MasterProduct } from "../../../models/inventory/master_product";
import { Brand } from "../../../models/inventory/brand";
import { ProductCategory } from "../../../models/inventory/product_category";
import { getBrands } from "../../../services/inventory/BrandApi";
import { getProductCategories } from "../../../services/inventory/ProductCategoryApi";
import CurrencyInput from "react-currency-input-field";

interface MasterProductFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: MasterProduct) => void;
  masterProduct?: MasterProduct;
}

const MasterProductForm: FC<MasterProductFormProps> = ({
  open,
  onClose,
  onSubmit,
  masterProduct,
}) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [productCategories, setProductCategories] = useState<ProductCategory[]>(
    []
  );
  const [data, setData] = useState<MasterProduct>({
    id: "",
    name: "",
    price: 0,
    prices: [],
    product_images: [],
  });

  const getAllBrands = async (search: string) => {
    getBrands({
      page: 1,
      size: 10,
      search,
    })
      .then((v) => v.json())
      .then((v) => setBrands(v.data.items));
  };
  const getAllProductCategories = async (search: string) => {
    getProductCategories({
      page: 1,
      size: 10,
      search,
    })
      .then((v) => v.json())
      .then((v) => setProductCategories(v.data.items));
  };
  useEffect(() => {
    setData(
      masterProduct || {
        id: "",
        name: "",
        price: 0,
        prices: [],
        product_images: [],
      }
    );
    getAllBrands("");
    getAllProductCategories("");
  }, [masterProduct]);

  return (
    <Modal size={"lg"} open={open} onClose={onClose}>
      <Modal.Header>
        <Modal.Title>Master Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-full">
          <div className="form-group">
            <label>Name</label>
            <Input
              name="name"
              placeholder="Name"
              value={data.name}
              onChange={(value, event) => setData({ ...data, name: value })}
            />
          </div>
          <div className="form-group">
            <label>Description</label>
            <Input
              as={"textarea"}
              rows={5}
              name="description"
              placeholder="Description"
              value={data.description}
              onChange={(value, event) =>
                setData({ ...data, description: value })
              }
            />
          </div>
          <div className="form-group">
            <label>SKU</label>
            <Input
              name="sku"
              placeholder="SKU"
              value={data.sku}
              onChange={(value, event) => setData({ ...data, sku: value })}
            />
          </div>
          <div className="form-group">
            <label>Barcode</label>
            <Input
              name="barcode"
              placeholder="Barcode"
              value={data.barcode}
              onChange={(value, event) => setData({ ...data, barcode: value })}
            />
          </div>
          <div className="form-group">
            <label>Price</label>
            <div className="input">
              <CurrencyInput
                className="rs-input"
                value={data.price}
                groupSeparator="."
                decimalSeparator=","
                onValueChange={(value, name, values) =>
                  setData({ ...data, price: values?.float ?? 0 })
                }
              />
            </div>
          </div>
          <div className="form-group">
            <label>Brand</label>
            <div className="input">
              <SelectPicker
                data={brands}
                name="brand"
                value={data.brand_id}
                onChange={(value, event) =>
                  setData({ ...data, brand_id: value! })
                }
                block
                valueKey="id"
                labelKey="name"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Category</label>
            <div className="input">
              <SelectPicker
                data={productCategories}
                name="productCategories"
                value={data.category_id}
                onChange={(value, event) =>
                  setData({ ...data, category_id: value! })
                }
                block
                valueKey="id"
                labelKey="name"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pt-4">
          <Button
            appearance="primary"
            onClick={() => {
              onSubmit(data!);
              setData({
                id: "",
                name: "",
                price: 0,
                prices: [],
                product_images: [],
              });
            }}
          >
            Submit
          </Button>
          <Button appearance="link" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default MasterProductForm;
